import { useState } from "react";
import useGetIntercom from "@/domains/hotel/hooks/useGetIntercom";
import useHotelHandlers from "@/domains/hotel/hooks/useHotelHandlers";
import HotelRoomControlContainer from "@/domains/hotel/containers/HotelRoomControlContainer";

type Props = {
  estateId: number | null;
};

export default function HotelIntercomContainer({ estateId }: Props) {
  const [isLockedRoom, setIsLockedRoom] = useState<boolean | null>(null);

  const { roomData, isLoading, onClose, load } = useGetIntercom(estateId, setIsLockedRoom);

  const { isResidentPending, setResident, toggleLockHotel, isSelling, sell } = useHotelHandlers(
    estateId,
    roomData?.hasResidence,
    roomData?.isLocked,
  );

  const handleToggleLock = () => toggleLockHotel(() => setIsLockedRoom((prev) => !prev));

  if (!isLoading && !roomData) {
    return null;
  }

  return (
    <HotelRoomControlContainer
      data={roomData}
      isLoading={isLoading}
      isResidentPending={isResidentPending}
      setResident={setResident}
      toggleLockHotel={handleToggleLock}
      isLockedRoom={isLockedRoom}
      onClose={onClose}
      isSelling={isSelling}
      sell={sell}
      refetch={load}
    />
  );
}
